import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import lodash from "lodash";

//internal components
import PublicHeaderNavigation from "../../../Common/Header/HeaderNavigation";
import BreadCrumbPanelNew from "../../../Common/BreadCrumbPanelNew";
import VendorNavigation from "../../../Common/VendorNavigation";
import ImageLoader from "../../../Common/ImageLoader";
import CategoryInfo from "../Common/CategoryInfo";
import SoftwareAwardCard from "../Common/SoftwareAwardCard";
import { composeArrayForRatings } from "../../../Common/CommonMethods";
import RatingStar from "../../../Common/RatingStar";
import CompetitorBoxesWithRouter from "../../../Common/PeerBoxes/CompetitorBoxes";
import SponsoredBox from "../../../Common/PeerBoxes/SponsoredBox";
import CompetitorPopUp from "../../../Common/Popups/Competitor";
import SponsoredPopUp from "../../../Common/Popups/SponsoredPopup";
import ClaimProfile from "../../../Common/Popups/ClaimProfile";
import ScrollHeaderVerified from "../../../Common/Header/ScrollHeaderVerified";
import AdditionalResources from "../../../Extranet/Profile/VendorProfile/Common/AdditionalResources";
import TestimonialBox from "../../VendorTestimonial/TestimonialPremium/TestimonialBox";
import VendorCaseStudy from "../../VendorCaseStudy/CaseStudyPremium/VendorCaseStudy";
import VideoBox from "../../VendorVideo/VideoPremium/VideoBox";
import shortid from "shortid";

const VerifiedProfileRefresh = (props) => {
  const [showPopUp, setShowPopUp] = useState(true);
  const [isUpgrade, setUpgrade] = useState(false);
  const [isShowMore, setShowMore] = useState(false);

  // Pop-Under Feature
  // useEffect(() => {
  //   if (
  //     !!props.vendorCommon &&
  //     !!props.vendorCommon.popunder &&
  //     !!props.vendorCommon.website
  //   ) {
  //     let storedVendor = window.localStorage.getItem("browsed_vendor");

  //     const websiteURL = new URL(props.vendorCommon.website);
  //     let URLWithoutParam = `${websiteURL.protocol}//${websiteURL.hostname}`;
  //     const regex = new RegExp(URLWithoutParam);
  //     if (!regex.test(storedVendor)) {
  //       if (!!storedVendor) {
  //         window.localStorage.setItem(
  //           "browsed_vendor",
  //           `${storedVendor},${props.vendorCommon.website}`
  //         );
  //       } else {
  //         window.localStorage.setItem(
  //           "browsed_vendor",
  //           `${props.vendorCommon.website}`
  //         );
  //       }
  //       //const newWin = window.open(document.URL, "_blank");
  //       const newWin = window.open(websiteURL, "_blank");
  //       if (!newWin || newWin.closed || typeof newWin.closed === "undefined") {
  //         alert(
  //           "Pop-ups are blocked. Please allow pop-ups from www.featuredcustomers.com"
  //         );
  //       }
  //       // else {
  //       //   setTimeout(() => {
  //       //     window.location.replace(props.vendorCommon.website);
  //       //   }, 3000);
  //       // }
  //     }
  //   }
  // }, [props.vendorCommon?.popunder, props.vendorCommon?.name]);

  const fallbackImages = lodash.shuffle([
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
  ]);

  const CustomerReferenceRatings = (props) => {
    return (
      <>
        {!!props.vendorCommon?.rating?.aggregate_score && (
          <>
            <div class="review_rating_score">
              <div class="left">
                <span class="review_heading">Customer Rating Review Score</span>
                based on {`${props.vendorCommon.rating.rated_by_user_count}`}{" "}
                reference ratings
              </div>
              <div class="right">
                <RatingStar
                  starCount={composeArrayForRatings(
                    props.vendorCommon.rating.aggregate_score
                  )}
                  profile
                  rated_by_user_count={
                    props.vendorCommon.rating.rated_by_user_count
                  }
                />
                <div class="txt">
                  {`${props.vendorCommon.rating.aggregate_score}/5.0`}{" "}
                  <span class="total_review">
                    {`(${props.vendorCommon.rating.rated_by_user_count})`}
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  };

  const hideShowContent = (event) => {
    event.preventDefault();
    const contentShowHide = document.querySelector(".showLessMoreContent");
    const hiddenItems = Array.prototype.slice.call(
      document.querySelectorAll(".contentHide")
    );

    const showing = contentShowHide.textContent === "Show more";

    hiddenItems.forEach(function (item) {
      if (!showing) {
        item.classList.add("content-hidden");
      } else {
        item.classList.remove("content-hidden");
      }

      contentShowHide.textContent =
        contentShowHide.textContent === "Show more" ? "Show Less" : "Show more";
    });
  };

  const setClaimProfilePopUpFalse = () => {
    setUpgrade(false);
  };

  const getThreeReviews = (reviews) => {
    let featuredReview = reviews.filter((review) => !!review.featured);
    let nonFeaturedReview = reviews.filter((review) => !review.featured);
    if (featuredReview.length === 3) {
      return featuredReview;
    } else if (featuredReview.length === 2) {
      return [...featuredReview, lodash.shuffle(nonFeaturedReview)[0]];
    } else if (featuredReview.length === 1) {
      return [
        ...featuredReview,
        ...lodash.shuffle(nonFeaturedReview).splice(0, 2),
      ];
    } else {
      return [...lodash.shuffle(nonFeaturedReview).splice(0, 3)];
    }
  };

  const getOneReviews = (reviews) => {
    let featuredReview = reviews.filter((review) => !!review.featured);
    let nonFeaturedReview = reviews.filter((review) => !review.featured);
    if (featuredReview.length > 0) {
      return [featuredReview[0]];
    } else {
      return [lodash.shuffle(nonFeaturedReview)[0]];
    }
  };

  return (
    <>
      {props?.vendorCommon?.competitors?.length === 3 && (
        <ScrollHeaderVerified vendorCommon={props.vendorCommon} />
      )}
      <PublicHeaderNavigation />

      <BreadCrumbPanelNew breadcrumbs={props.vendorProfile?.breadcrumb_links} />

      <section>
        <div className="middleSection vendor_profile_section">
          <div className="container">
            <div class="vendor_profile_description">
              <div class="left_section">
                {!!props.vendorCommon &&
                !!props.vendorCommon.name &&
                !!props.vendorCommon.vendor_type &&
                props.vendorCommon.vendor_type === "verified" ? (
                  <div class="top_header">
                    <h1>{props.vendorCommon.name}</h1>
                    <span class="verifiedBadge">Verified</span>
                  </div>
                ) : (
                  ``
                )}

                <div class="description_block">
                  {`Read ${
                    !!props.vendorCommon?.testimonial_count
                      ? props.vendorCommon?.testimonial_count
                      : ""
                  } ${
                    props.vendorCommon?.name
                  } reviews and testimonials from customers, explore ${
                    !!props.vendorCommon?.casestudy_count
                      ? props.vendorCommon?.casestudy_count
                      : ""
                  } case studies and customer success stories, and watch ${
                    !!props.vendorCommon?.video_count
                      ? props.vendorCommon?.video_count
                      : ""
                  } customer videos to see why companies chose ${
                    props.vendorCommon?.name
                  } as their ${props.vendorProfile?.categories[0]?.name}`}
                </div>
                {!!props.vendorCommon.logo && (
                  <div className="vendor_logo">
                    <ImageLoader
                      image={props.vendorCommon.logo}
                      fallbackImage={"/static/images/FC-Generic-Logo.webp"}
                      width={150}
                      height={45}
                    />
                  </div>
                )}
                <div className="content_block">
                  <div className={isShowMore ? "show" : "hide"}>
                    {props.vendorProfile?.description
                      .split("\r\n")
                      .map((textObj) => (
                        <p>{textObj}</p>
                      ))}
                  </div>
                  <a
                    href="#show more"
                    className="showLessMoreContent"
                    onClick={(e) => {
                      e.preventDefault();
                      hideShowContent(e);
                      setShowMore(!isShowMore);
                    }}
                  >
                    {isShowMore ? "Show less" : "Show more"}
                  </a>
                </div>
                <div class="category">
                  {props.vendorProfile.categories.length > 0 && (
                    <CategoryInfo />
                  )}
                </div>
              </div>
              <div class="right_section">
                <div class="reviews_content_block">
                  <div class="content_block">
                    <ul>
                      <li class="testimonials">
                        {!!props.vendorCommon?.testimonial_count ? (
                          <span className="number">
                            {props.vendorCommon?.testimonial_count}
                          </span>
                        ) : (
                          <span className="no_reviews">
                            {" "}
                            No <br />
                            Testimonials Yet{" "}
                          </span>
                        )}

                        <span
                          class={
                            !!props.vendorCommon?.testimonial_count
                              ? "name"
                              : "name no"
                          }
                        >
                          Testimonials
                        </span>
                        {!!props.vendorCommon?.testimonial_count && (
                          <span class="view">
                            <a href={`#testimonials-review`}>View</a>
                          </span>
                        )}
                      </li>
                      <li class="case_studies">
                        {!!props.vendorCommon?.casestudy_count ? (
                          <span className="number">
                            {props.vendorCommon?.casestudy_count}
                          </span>
                        ) : (
                          <span className="no_reviews">
                            No <br />
                            Case Studies Yet
                          </span>
                        )}

                        <span
                          class={
                            !!props.vendorCommon?.casestudy_count
                              ? "name"
                              : "name no"
                          }
                        >
                          Case Studies
                        </span>
                        {!!props.vendorCommon?.casestudy_count && (
                          <span class="view">
                            <a href={`#case-studies-review`}>View</a>
                          </span>
                        )}
                      </li>
                      <li class="videos">
                        {!!props.vendorCommon?.video_count ? (
                          <span className="number">
                            {props.vendorCommon?.video_count}
                          </span>
                        ) : (
                          <span className="no_reviews">
                            {" "}
                            No <br />
                            Videos Yet{" "}
                          </span>
                        )}

                        <span
                          class={
                            !!props.vendorCommon?.video_count
                              ? "name"
                              : "name no"
                          }
                        >
                          Customer Videos
                        </span>
                        {!!props.vendorCommon?.video_count && (
                          <span class="view">
                            <a href={`#customer-videos-review`}>View</a>
                          </span>
                        )}
                      </li>
                    </ul>
                  </div>
                  {CustomerReferenceRatings(props)}
                </div>
                {props.vendorProfile?.reports?.length +
                  props.vendorProfile?.awards?.length >
                0 ? (
                  props.vendorProfile?.show_awards ||
                  !props.vendorProfile?.should_blur ? (
                    <SoftwareAwardCard />
                  ) : (
                    <div class="award_block">
                      <div class="award_list_block">
                        <div class="award_blur_img">
                          <img
                            src="/images/vendor_profile_blur_img.png"
                            alt=""
                          />
                        </div>
                        <span class="hiddenAward">{`${
                          props.vendorProfile?.reports?.length +
                          props.vendorProfile?.awards?.length
                        } AWARDS CURRENTLY HIDDEN`}</span>
                      </div>
                    </div>
                  )
                ) : null}
              </div>
            </div>
            {props.vendorCommon.show_sponsored_popup && (
              <div class="vendor_profile_sponsored_section">
                <div class="top_header">
                  <h2>{`Check out this Top Rated ${props.vendorCommon.name} alternative`}</h2>
                  <div class="sponsored_btn">
                    <a href="#">Sponsored</a>
                  </div>
                </div>
                <ul>
                  <li class="left">
                    {[
                      ...props.vendorCommon?.sponsored?.awards,
                      ...props.vendorCommon?.sponsored?.reports,
                    ].length > 0 ? (
                      <span class="badge badgeMarketLeader">
                        {
                          [
                            ...props.vendorCommon?.sponsored?.awards,
                            ...props.vendorCommon?.sponsored?.reports,
                          ].filter((obj) => !!obj.classification)[0]
                            ?.classification
                        }
                      </span>
                    ) : null}
                    <div class="logo">
                      <img src={props.vendorCommon?.sponsored?.logo} alt="" />
                    </div>
                    <div class="review_rating_block">
                      <div class="left">Customer Rating Review Score</div>
                      <div class="right">
                        <div className="starRating">
                          <div className="rating">
                            <RatingStar
                              starCount={composeArrayForRatings(
                                props.vendorCommon?.sponsored?.rating
                                  ?.aggregate_score
                              )}
                              inline
                              withoutO
                            />
                          </div>
                          <div class="ratingTxt">
                            {`${props.vendorCommon?.sponsored?.rating?.aggregate_score} / 5.0 `}
                            <span class="totalReferences">
                              {` (${props.vendorCommon?.sponsored?.rating?.rated_by_user_count})`}
                            </span>
                          </div>
                        </div>

                        {/* <div class="starRating">
                          <div class="rating">
                            <i class="fa fa-star-o" aria-hidden="true">
                              <i
                                class="fa fa-star outline hundred"
                                aria-hidden="true"
                              ></i>
                            </i>
                            <i class="fa fa-star-o" aria-hidden="true">
                              <i
                                class="fa fa-star outline hundred"
                                aria-hidden="true"
                              ></i>
                            </i>
                            <i class="fa fa-star-o" aria-hidden="true">
                              <i
                                class="fa fa-star outline hundred"
                                aria-hidden="true"
                              ></i>
                            </i>
                            <i class="fa fa-star-o" aria-hidden="true">
                              <i
                                class="fa fa-star outline hundred"
                                aria-hidden="true"
                              ></i>
                            </i>
                            <i class="fa fa-star-o" aria-hidden="true">
                              <i
                                class="fa fa-star outline eighty"
                                aria-hidden="true"
                              ></i>
                            </i>
                          </div>
                          <div class="ratingTxt">
                            4.8 / 5.0
                            <span class="totalReferences">(1631)</span>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <p>{props.vendorCommon?.sponsored?.description}</p>
                    <span class="more">
                      <a href={props.vendorCommon?.sponsored?.profile_url}>
                        {`Learn more about ${props.vendorCommon?.sponsored?.name}`}
                      </a>
                    </span>
                  </li>
                  <li class="cls_review_block">
                    <ul>
                      {props.vendorCommon?.sponsored?.testimonial_count ? (
                        <li class="tts">
                          <span class="icon"></span>
                          <div class="txt">
                            {`${props.vendorCommon?.sponsored?.testimonial_count} Testimonials`}
                            <span class="view_btn">
                              <Link
                                to={`${props.vendorCommon?.sponsored?.profile_url}/testimonials`}
                              >
                                View
                              </Link>
                            </span>
                          </div>
                        </li>
                      ) : null}
                      {props.vendorCommon?.sponsored?.casestudy_count ? (
                        <li class="cs">
                          <span class="icon"></span>
                          <div class="txt">
                            {`${props.vendorCommon?.sponsored?.casestudy_count} Case Studies`}
                            <span class="view_btn">
                              <Link
                                to={`${props.vendorCommon?.sponsored?.profile_url}/case-studies`}
                              >
                                View
                              </Link>
                            </span>
                          </div>
                        </li>
                      ) : null}
                      {props.vendorCommon?.sponsored?.video_count ? (
                        <li class="vd">
                          <span class="icon"></span>
                          <div class="txt">
                            {`${props.vendorCommon?.sponsored?.video_count} Videos`}
                            <span class="view_btn">
                              <Link
                                to={`${props.vendorCommon?.sponsored?.profile_url}/customer-videos`}
                              >
                                View
                              </Link>
                            </span>
                          </div>
                        </li>
                      ) : null}
                    </ul>
                  </li>
                </ul>
              </div>
            )}
            {props.vendorProfile?.featured_references?.testimonials?.length >
            0 ? (
              props.vendorProfile?.should_blur === true ? (
                <div
                  class="vendor_reviews_section testimonials"
                  id="testimonials-review"
                >
                  <h3>
                    <span class="count">
                      {!!props.vendorCommon?.testimonial_count &&
                        props.vendorCommon?.testimonial_count}
                    </span>
                    Testimonials
                  </h3>
                  <div class="testimonial_reviews clsVerified">
                    <ul
                      className={
                        props.vendorProfile?.num_unblurred_reviews === 2
                          ? "cls_vendor_blur"
                          : ""
                      }
                    >
                      {props.vendorProfile?.featured_references?.testimonials
                        .slice(0, props.vendorProfile?.num_unblurred_reviews)
                        .map((reviews) => (
                          <TestimonialBox
                            key={shortid.generate()}
                            {...reviews}
                            pathname={props.location.pathname}
                            isLeadGenPopUp={
                              props.vendorProfile?.is_lead_generate_popup
                            }
                            totalRefCount={
                              props.vendorCommon?.casestudy_count
                                ? props.vendorCommon?.casestudy_count +
                                  props.vendorCommon?.testimonial_count +
                                  props.vendorCommon?.video_count
                                : 0
                            }
                            companyId={
                              props.vendorCommon?.company_id
                                ? props.vendorCommon?.company_id
                                : -1
                            }
                            linkedInUrl={
                              props.vendorTestimonials?.linkedin_signin_url
                            }
                          />
                        ))}
                      {[
                        ...new Array(
                          3 - props.vendorProfile?.num_unblurred_reviews
                        ),
                      ].map((obj) => {
                        if (props.vendorProfile?.num_unblurred_reviews === 2) {
                          return (
                            <li className="cls_blur">
                              <img src="/images/blur_img.png" alt="" />
                              <div
                                class="content_locked"
                                onClick={(e) => setUpgrade(true)}
                              >
                                <span class="heading_txt">
                                  {props.vendorCommon?.testimonial_count -
                                    props.vendorProfile
                                      ?.num_unblurred_reviews}{" "}
                                  more testimonials
                                </span>
                                <span class="locked">currently locked</span>
                              </div>
                            </li>
                          );
                        } else {
                          return (
                            <li>
                              <img src="/images/blur_img.png" alt="" />
                            </li>
                          );
                        }
                      })}
                    </ul>
                    {props.vendorProfile?.num_unblurred_reviews === 2 ? (
                      ``
                    ) : (
                      <div
                        class="content_locked"
                        onClick={(e) => setUpgrade(true)}
                      >
                        <span class="heading_txt">
                          {props.vendorCommon?.testimonial_count -
                            props.vendorProfile?.num_unblurred_reviews}{" "}
                          more testimonials
                        </span>
                        <span class="locked">currently locked</span>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  class="vendor_reviews_section testimonials"
                  id="testimonials-review"
                >
                  <h3>Featured Testimonials</h3>
                  <div class="testimonial_reviews">
                    <ul>
                      {props.vendorProfile?.featured_references?.testimonials.map(
                        (reviews) => (
                          <TestimonialBox
                            key={shortid.generate()}
                            {...reviews}
                            pathname={props.location.pathname}
                            isLeadGenPopUp={
                              props.vendorProfile?.is_lead_generate_popup
                            }
                            totalRefCount={
                              props.vendorCommon?.casestudy_count
                                ? props.vendorCommon?.casestudy_count +
                                  props.vendorCommon?.testimonial_count +
                                  props.vendorCommon?.video_count
                                : 0
                            }
                            companyId={
                              props.vendorCommon?.company_id
                                ? props.vendorCommon?.company_id
                                : -1
                            }
                            linkedInUrl={
                              props.vendorTestimonials?.linkedin_signin_url
                            }
                          />
                        )
                      )}
                    </ul>
                  </div>
                  <div class="load_more_btn testimonial_btn">
                    <Link to={`/vendor/${props.match.params.id}/testimonials`}>
                      Load additional Testimonials
                    </Link>
                  </div>
                </div>
              )
            ) : (
              ``
            )}
            {props.vendorProfile?.featured_references?.case_studies?.length >
            0 ? (
              props.vendorProfile?.should_blur === true ? (
                <div
                  class="vendor_reviews_section case_study"
                  id="case-studies-review"
                >
                  <h3>
                    <span class="count">
                      {!!props.vendorCommon?.casestudy_count &&
                        props.vendorCommon?.casestudy_count}
                    </span>{" "}
                    Case Studies
                  </h3>
                  <div class="case_study_reviews clsVerified">
                    <ul
                      className={
                        props.vendorProfile?.num_unblurred_reviews === 2
                          ? "cls_vendor_blur"
                          : ""
                      }
                    >
                      {props.vendorProfile?.featured_references?.case_studies
                        .slice(0, props.vendorProfile?.num_unblurred_reviews)
                        .map((reviews) => (
                          <VendorCaseStudy
                            key={shortid.generate()}
                            {...reviews}
                            pathname={props.location.pathname}
                            isLeadGenPopUp={
                              props.vendorProfile.is_lead_generate_popup
                            }
                            totalRefCount={
                              props.vendorCommon.casestudy_count
                                ? props.vendorCommon.casestudy_count +
                                  props.vendorCommon.testimonial_count +
                                  props.vendorCommon.video_count
                                : 0
                            }
                            companyId={
                              props.vendorCommon.company_id
                                ? props.vendorCommon.company_id
                                : -1
                            }
                            linkedInUrl={
                              props?.vendorCaseStudies?.linkedin_signin_url
                            }
                          />
                        ))}
                      {[
                        ...new Array(
                          3 - props.vendorProfile?.num_unblurred_reviews
                        ),
                      ].map((obj) => {
                        if (props.vendorProfile?.num_unblurred_reviews === 2) {
                          return (
                            <li className="cls_blur">
                              <img src="/images/blur_img.png" alt="" />
                              <div
                                class="content_locked"
                                onClick={(e) => setUpgrade(true)}
                              >
                                <span class="heading_txt">
                                  {props.vendorCommon?.casestudy_count -
                                    props.vendorProfile
                                      ?.num_unblurred_reviews}{" "}
                                  more case studies
                                </span>
                                <span class="locked">currently locked</span>
                              </div>
                            </li>
                          );
                        } else {
                          return (
                            <li>
                              <img src="/images/blur_img.png" alt="" />
                            </li>
                          );
                        }
                      })}
                    </ul>
                    {props.vendorProfile?.num_unblurred_reviews === 2 ? (
                      ``
                    ) : (
                      <div
                        class="content_locked"
                        onClick={(e) => setUpgrade(true)}
                      >
                        <span class="heading_txt">
                          {props.vendorCommon?.casestudy_count -
                            props.vendorProfile?.num_unblurred_reviews}{" "}
                          more case studies
                        </span>
                        <span class="locked">currently locked</span>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  class="vendor_reviews_section case_study"
                  id="case-studies-review"
                >
                  <h3>Featured Case Studies</h3>
                  <div class="case_study_reviews">
                    <ul>
                      {props.vendorProfile?.featured_references?.case_studies.map(
                        (reviews) => (
                          <VendorCaseStudy
                            key={shortid.generate()}
                            {...reviews}
                            pathname={props.location.pathname}
                            isLeadGenPopUp={
                              props.vendorProfile.is_lead_generate_popup
                            }
                            totalRefCount={
                              props.vendorCommon.casestudy_count
                                ? props.vendorCommon.casestudy_count +
                                  props.vendorCommon.testimonial_count +
                                  props.vendorCommon.video_count
                                : 0
                            }
                            companyId={
                              props.vendorCommon.company_id
                                ? props.vendorCommon.company_id
                                : -1
                            }
                            linkedInUrl={
                              props?.vendorCaseStudies?.linkedin_signin_url
                            }
                          />
                        )
                      )}
                    </ul>
                  </div>
                  <div class="load_more_btn case_study_btn">
                    <Link to={`/vendor/${props.match.params.id}/case-studies`}>
                      Load additional Case Studies
                    </Link>
                  </div>
                </div>
              )
            ) : (
              ``
            )}
            {props.vendorProfile?.featured_references?.videos?.length > 0 ? (
              props.vendorProfile?.should_blur === true ? (
                <div
                  class="vendor_reviews_section video"
                  id="customer-videos-review"
                >
                  <h3>
                    <span class="count">
                      {!!props.vendorCommon?.video_count &&
                        props.vendorCommon?.video_count}
                    </span>{" "}
                    Customer Videos
                  </h3>
                  <div class="video_reviews clsVerified">
                    <ul
                      className={
                        props.vendorProfile?.num_unblurred_reviews === 2
                          ? "cls_vendor_blur"
                          : ""
                      }
                    >
                      {props.vendorProfile?.featured_references?.videos
                        .slice(0, props.vendorProfile?.num_unblurred_reviews)
                        .map((reviews, index) => (
                          <VideoBox
                            key={shortid.generate()}
                            {...reviews}
                            vendorName={props.vendorCommon?.name}
                            pathname={props.location?.pathname}
                            isLeadGenPopUp={
                              props.vendorProfile?.is_lead_generate_popup
                            }
                            totalRefCount={
                              props.vendorCommon?.casestudy_count
                                ? props.vendorCommon?.casestudy_count +
                                  props.vendorCommon?.testimonial_count +
                                  props.vendorCommon?.video_count
                                : 0
                            }
                            companyId={
                              props.vendorCommon?.company_id
                                ? props.vendorCommon?.company_id
                                : -1
                            }
                            imageIndex={fallbackImages[index % 19]}
                            linkedInUrl={
                              props.vendorVideos?.linkedin_signin_url
                            }
                          />
                        ))}
                      {[
                        ...new Array(
                          3 - props.vendorProfile?.num_unblurred_reviews
                        ),
                      ].map((obj) => {
                        if (props.vendorProfile?.num_unblurred_reviews === 2) {
                          return (
                            <li className="cls_blur">
                              <img src="/images/blur_img.png" alt="" />
                              <div
                                class="content_locked"
                                onClick={(e) => setUpgrade(true)}
                              >
                                <span class="heading_txt">
                                  {props.vendorCommon?.video_count -
                                    props.vendorProfile
                                      ?.num_unblurred_reviews}{" "}
                                  more videos
                                </span>
                                <span class="locked">currently locked</span>
                              </div>
                            </li>
                          );
                        } else {
                          return (
                            <li>
                              <img src="/images/blur_img.png" alt="" />
                            </li>
                          );
                        }
                      })}
                    </ul>
                    {props.vendorProfile?.num_unblurred_reviews === 2 ? (
                      ``
                    ) : (
                      <div
                        class="content_locked"
                        onClick={(e) => setUpgrade(true)}
                      >
                        <span class="heading_txt">
                          {props.vendorCommon?.video_count -
                            props.vendorProfile?.num_unblurred_reviews}{" "}
                          more videos
                        </span>
                        <span class="locked">currently locked</span>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  class="vendor_reviews_section video"
                  id="customer-videos-review"
                >
                  <h3>Featured Customer Videos</h3>
                  <div class="video_reviews">
                    <ul>
                      {props.vendorProfile?.featured_references?.videos.map(
                        (reviews, index) => (
                          <VideoBox
                            key={shortid.generate()}
                            {...reviews}
                            vendorName={props.vendorCommon?.name}
                            pathname={props.location?.pathname}
                            isLeadGenPopUp={
                              props.vendorProfile?.is_lead_generate_popup
                            }
                            totalRefCount={
                              props.vendorCommon?.casestudy_count
                                ? props.vendorCommon?.casestudy_count +
                                  props.vendorCommon?.testimonial_count +
                                  props.vendorCommon?.video_count
                                : 0
                            }
                            companyId={
                              props.vendorCommon?.company_id
                                ? props.vendorCommon?.company_id
                                : -1
                            }
                            imageIndex={fallbackImages[index % 19]}
                            linkedInUrl={
                              props.vendorVideos?.linkedin_signin_url
                            }
                          />
                        )
                      )}
                    </ul>
                  </div>
                  <div class="load_more_btn video_btn">
                    <Link
                      to={`/vendor/${props.match.params.id}/customer-videos`}
                    >
                      Load additional Videos
                    </Link>
                  </div>
                </div>
              )
            ) : (
              ``
            )}
            <AdditionalResources />
          </div>
        </div>
      </section>

      {showPopUp && props.vendorCommon.show_sponsored_popup && (
        <SponsoredPopUp
          {...props.vendorCommon.sponsored}
          vendor={props.vendorCommon.name}
          setShowPopUp={setShowPopUp}
          setUpgrade={setUpgrade}
        />
      )}
      {!props.vendorCommon.show_sponsored_popup &&
        !!props.vendorCommon.competitors.length && <CompetitorPopUp />}
      {isUpgrade ? (
        <ClaimProfile
          companyName={props.vendorCommon.name}
          companyId={props.vendorCommon.company_id}
          setClaimProfilePopUpFalse={setClaimProfilePopUpFalse}
        />
      ) : null}
    </>
  );
};

const VerifiedProfileRefreshhWithRouter = withRouter(VerifiedProfileRefresh);
const mapStateToProps = (state) => {
  return {
    vendorCommon: state.vendorCommon,
    vendorProfile: state.vendorProfile,
    vendorTestimonials: state.vendorTestimonials,
    vendorCaseStudies: state.vendorCaseStudies,
    vendorVideos: state.vendorVideos,
  };
};

export default connect(mapStateToProps)(VerifiedProfileRefreshhWithRouter);
